import { Card, CardContent } from "../ui/card";
import { Navigation, Clock } from "lucide-react";

function formatDuration(seconds) {
  if (!seconds) return "N/A";
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const hours = Math.floor(mins / 60);
  const remainingMins = mins % 60;
  return `${hours}h ${remainingMins}m`;
}

function formatDistance(meters) {
  if (!meters) return "N/A";
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
}

export function RouteSummary({ routeData }) {
  if (!routeData) return null;

  return (
    <div className="mt-3 flex gap-2">
      <Card className="flex-1 bg-white/90 backdrop-blur-md border-0 shadow-lg">
        <CardContent className="p-3 flex items-center gap-2">
          <Navigation className="w-4 h-4 text-blue-500" />
          <div>
            <p className="text-xs text-slate-500">Total Distance</p>
            <p className="font-bold text-slate-900">
              {formatDistance(routeData.total_distance)}
            </p>
          </div>
        </CardContent>
      </Card>
      <Card className="flex-1 bg-white/90 backdrop-blur-md border-0 shadow-lg">
        <CardContent className="p-3 flex items-center gap-2">
          <Clock className="w-4 h-4 text-green-500" />
          <div>
            <p className="text-xs text-slate-500">Est. Time</p>
            <p className="font-bold text-slate-900">
              {formatDuration(routeData.total_duration)}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
